import React from "react";
import CoreIntegrationPanel from "@/components/CoreIntegrationPanel";
import CreToolsIntegrationPanel from "@/components/CreToolsIntegrationPanel";

export default function IntegrationsPage() {
  return (
    <div className="px-6 lg:px-10 py-8" data-testid="integrations-page">
      <div className="mb-8">
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-500 mb-2">Connections</div>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight">Integrations</h1>
        <p className="text-sm text-neutral-500 mt-2 max-w-2xl">
          Connect Ledger to the systems you already use. Deals sync automatically into your pipeline; live KPIs surface on your dashboard.
        </p>
      </div>

      <CoreIntegrationPanel />
      <CreToolsIntegrationPanel />
    </div>
  );
}
